import { baseUrlUser } from '../../../../constants/url.constant';
import { OrderModel } from '../../../orders/models/OrderModel';
import { OrderUtils } from '../../../orders/views/shared/OrderUtils';
import { ProductUtils } from '../../../products/views/ProductUtils';
import { ShortInvoiceModel } from '../../models/InvoiceModel';
import moreIcon from "../../../../assets/images/more.png";

export type InvoiceOrderListProps = {
    invoice: ShortInvoiceModel;
}

export default function InvoiceOrderListView({ invoice }: InvoiceOrderListProps) {
    const itemCount = invoice.items.length;
    const items = itemCount <= 8 ? invoice.items : invoice.items.slice(0, 7);

    return <div>
        {items.map((item: OrderModel, index: number) => {
            let url = item.product ? ProductUtils.getImageUrl(baseUrlUser, item.product.picture) : "";

            return <div key={item.id} style={{ width: "22%", display: "inline-flex" }}>
                {OrderUtils.image(url, item.qty, 50, 0, false)}
            </div>
        })}

        {itemCount > 8 &&
            <div className="center pv-5" style={{ width: "22%", display: "inline-block" }}>
                <img src={moreIcon} width={40} height={40} />
            </div>}
    </div>
}